import { render, staticRenderFns } from "./BuyerAccountParameterSettings.vue?vue&type=template&id=4fa05d65&scoped=true"
import script from "./BuyerAccountParameterSettings.vue?vue&type=script&lang=js"
export * from "./BuyerAccountParameterSettings.vue?vue&type=script&lang=js"
import style0 from "./BuyerAccountParameterSettings.vue?vue&type=style&index=0&id=4fa05d65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa05d65",
  null
  
)

export default component.exports